/**
 * Asking the AI Worker for a draft.
 *
 * The same rules as the account and sync clients: a relative URL because the Worker is on this
 * origin, the session cookie is what authenticates it, and the answer is *parsed* rather than
 * trusted — a proposal that does not match its schema is a refusal, not a map, because the next
 * thing that happens to it is that somebody creates a document out of it.
 *
 * The document is parsed by `parseDocument`, which walks the tree afterwards. That check is the
 * one that matters here: a model's output has been through a schema on the server, and this is
 * the boundary where the *client* decides whether what arrived is a map it can open. A generated
 * document that failed it would be a map the editor refuses the moment somebody accepts it.
 */
import { createApiClient } from '@orbit-mind/api-client';
import { readOwnAi } from '../account/ownAi';
import { getDeviceLocale } from '@orbit-mind/shared-types';

export type { GeneratedProposal } from '@orbit-mind/api-client';

// Late-bound for the same reason as the account client: tests replace the global per case.
const client = createApiClient({
  ownAi: readOwnAi,
  fetch: (input, init) => globalThis.fetch(input, init),
  deviceLocale: () => getDeviceLocale(navigator.languages),
});

export const generate = client.generate;
export const recoverGeneration = client.recoverGeneration;
